import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { chatwootSession } from '../../actions/chatwoot';
import { applyChatwootBubbleVisibility, markChatwootClosed, markChatwootOpen } from '../../utils/chatwoot';

const CHATWOOT_SCRIPT_ID = 'chatwoot-sdk-script';

class ChatwootWidget extends React.Component {
  isUnmounted = false;

  pendingSession = null;

  componentDidMount() {
    this.loadChatwoot();
  }

  componentWillUnmount() {
    this.isUnmounted = true;
    window.removeEventListener('chatwoot:ready', this.handleChatwootReady);
    window.removeEventListener('chatwoot:opened', markChatwootOpen);
    window.removeEventListener('chatwoot:closed', markChatwootClosed);
  }

  handleChatwootReady = () => {
    if (!this.pendingSession || !window.$chatwoot) {
      return;
    }

    const { identifier, identifier_hash, user = {}, custom_attributes = {} } = this.pendingSession;
    window.$chatwoot.setUser(identifier, {
      identifier_hash,
      name: user.name,
      email: user.email,
      company_name: user.organization_name,
    });

    window.$chatwoot.setCustomAttributes({
      ...custom_attributes,
      current_path: window.location.pathname,
      user_agent: window.navigator.userAgent,
    });
    applyChatwootBubbleVisibility();
  };

  loadChatwoot = () => {
    const { getChatwootSession } = this.props;

    getChatwootSession().then(result => {
      const session = result?.response;
      if (this.isUnmounted || !session?.enabled) {
        return;
      }

      this.pendingSession = session;

      window.chatwootSettings = {
        hideMessageBubble: true,
        position: 'right',
        locale: 'en',
        type: 'standard',
      };

      window.addEventListener('chatwoot:ready', this.handleChatwootReady);
      window.addEventListener('chatwoot:opened', markChatwootOpen);
      window.addEventListener('chatwoot:closed', markChatwootClosed);

      if (window.$chatwoot) {
        this.handleChatwootReady();
        return;
      }

      if (document.getElementById(CHATWOOT_SCRIPT_ID)) {
        if (window.chatwootSDK) {
          window.chatwootSDK.run({
            websiteToken: session.website_token,
            baseUrl: session.base_url,
          });
        }
        return;
      }

      const script = document.createElement('script');
      script.id = CHATWOOT_SCRIPT_ID;
      script.async = true;
      script.src = `${session.base_url}/packs/js/sdk.js`;
      script.onload = () => {
        if (window.chatwootSDK) {
          window.chatwootSDK.run({
            websiteToken: session.website_token,
            baseUrl: session.base_url,
          });
        }
      };
      document.body.appendChild(script);
    });
  };

  render() {
    return null;
  }
}

ChatwootWidget.propTypes = {
  getChatwootSession: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  getChatwootSession: () => dispatch(chatwootSession()),
});

export default connect(null, mapDispatchToProps)(ChatwootWidget);
